import { Formik } from "formik";
import { Col, Form, Row } from "react-bootstrap";

export function IPListEditForm({
  IPList,
  btnRef,
  saveIPList
}) {
  return (
    <Formik
      enableReinitialize={true}
      initialValues={IPList}
      onSubmit={(values) => {
        saveIPList(values);
      }}
    >
      {({ handleSubmit, handleChange, values }) => (
        <Form onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}>          
          <Form.Group as={Row} controlId="IPList">
            <Form.Label column sm={3}>
              IP Listesi
            </Form.Label>
            <Col sm={9}>
              <Form.Control
                as="textarea"
                rows="3"
                placeholder="IP Listesi"
                value={values.IPList}
                onChange={handleChange}
              />
            </Col>
          </Form.Group>

          <button
            type="submit"
            style={{ display: "none" }}
            ref={btnRef}
          ></button>
        </Form>
      )}      
    </Formik>
  );
}